// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"CategoryTabs_tabsWrapper__nclHo"};